import UIThemeProvider from './UIThemeProvider'
export default UIThemeProvider
